$(document).ready(function () {

	$.blockUI.defaults.message = 'Aguarde...';

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}


	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		/*$('#loader').fadeOut(500, function () {
			$(this).remove();
		});*/
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy) e a class do efeito desejado (ex: .load-img)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) { //is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) { //is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else { //is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

var app = new Vue({
	el: "#quiz",
	data: {
		feedback: {
			message: '',
			class: ''
		},
		form: {
			firstName: {
				value: '',
				hasError: false
			},
			lastName: {
				value: '',
				hasError: false	
			},
			nif: {
				value: '',
				hasError: false	
			},
			city: {
				value: '',
				hasError: false	
			},
			teamSize: {
				value: 0,
				hasError: false
			},
			email: {
				value: '',
				hasError: false
			},
			phone: {
				value: '',
				hasError: false
			},
			gama: {
				value: [],
				hasError: false
			},
			consent_registo: 'no',
			consent_marketing: 'no'
		},
		timer: null,
		elapsedTime: 0,
		startTime: null,
		step: 0,
		questionIndex: 0,
		autoNextQuestion: 1500,
		wrongAnswers: 0,
		questions: [
			{
				question: 'Em 2024,a SECILTEK ganhou:',
				image: 'images/questions/premios-universidades.jpg',
				answers: [
					{
						text: 'A escolha dos profissionais',
						correct: true,
					},
					{
						text: 'Estrela Michelin',
					},
					{
						text: 'Prémio 5 estrelas',
					},
					{
						text: 'Produtos de excelência',
					}
				]
			},
			{
				question: 'Qual o cimento cola recomendado para colar cerâmicos sobre cerâmicos?',
				image: 'images/questions/colagem-e-betumacao-de-ceramicos-em-paredes-interiores.jpg',
				answers: [
					{
						text: 'ADHERE Ci 1.0',
					},
					{
						text: 'ADHERE FLEX TT',
						correct: true
					},
					{
						text: 'ADHERE CAL',
					},
					{
						text: 'ADHERE COR 05',
					}
				]
			},
			{
				question: 'Qual o sistema de isolamento térmico mais sustentável?',
				image: 'images/questions/shutterstock-2464823423.jpg',
				answers: [
					{
						text: 'ISOVIT CLÁSSICO (EPS)',
					},
					{
						text: 'ISOVIT CORK (Cortiça)',
						correct: true
					},
					{
						text: 'ISODUR',
					},
					{
						text: 'REDUR K-COLOR',
					}
				]
			},
			{
				question: 'Que gama Seciltek tem o superpoder dos revestimentos?',
				image: 'images/questions/seciltek.jpg',
				answers: [
					{
						text: 'PLAN',
					},
					{
						text: 'REDUR',
						correct: true
					},
					{
						text: 'B-REPARA',
					},
					{
						text: 'BETÃO-S',
					}
				]
			}
		],
	},
	created() {
		this.shuffleQuestionsAndAnswers();
	},
	
	methods: {

		shuffleQuestionsAndAnswers() {
			// Shuffle the questions array
			this.questions = this.questions
			  .map(value => ({ value, sort: Math.random() }))
			  .sort((a, b) => a.sort - b.sort)
			  .map(({ value }) => value);
		
			// Shuffle the answers within each question
			this.questions.forEach(question => {
			  question.answers = question.answers
				.map(value => ({ value, sort: Math.random() }))
				.sort((a, b) => a.sort - b.sort)
				.map(({ value }) => value);
			});
		},

		goToStep: function (step) {
			this.step = step;
		},

		goToStep2: function () {
			this.form.firstName.hasError = false;
			this.form.lastName.hasError = false;
			this.form.nif.hasError = false;
			this.form.city.hasError = false;

			if($.trim(this.form.firstName.value) == ''){
				this.form.firstName.hasError = true;
			} 
			else if($.trim(this.form.nif.value) == '') {
				this.form.nif.hasError = true;
			} 
			else if($.trim(this.form.city.value) == '') {
				this.form.city.hasError = true;
			} else {
				this.step = 2;
			}
		},

		goToStep3: function () {
			this.form.email.hasError = false;
			this.form.phone.hasError = false;

			if($.trim(this.form.email.value) != '' && !this.validateEmail(this.form.email.value)){
				this.form.email.hasError = true;
			} else if($.trim(this.form.phone.value) == ''){
				this.form.phone.hasError = true;
			} else {
				this.step = 3;
			}
		},

		goToStep4: function () {
			this.form.gama.hasError = false;

			if($.trim(this.form.gama.value) == ''){
				this.form.gama.hasError = true;
			} else {
				this.step = 4;
			}
		},

		validateEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email) ? true : false;
		},

		prevStep() {
			this.step = this.step - 1;
		},

		startQuiz() {
			if(this.form.consent_registo == 'yes' && this.form.consent_marketing == 'yes'){

				this.step = 6;
				this.startTimer();
			} else {
				alert('Por favor aceite os termos de tratamento e utilização de dados.');
				return false;
			}
		},

		startTimer() {
			this.startTime = performance.now();
			this.timer = setInterval(() => {
				const elapsedTime = performance.now() - this.startTime;

				const seconds = (elapsedTime / 1000).toFixed(3);

				this.elapsedTime = seconds;
			}, 10);
		},

		stopTimer() {
			clearInterval(this.timer);
		},

		selectAnswer: function (answer) {
			this.questions[this.questionIndex].answers.forEach((value, index) => {
				if(this.questions[this.questionIndex].answers[index].correct){
					Vue.set(this.questions[this.questionIndex].answers[index], 'showCorrect', true);
				}
			});
			Vue.set(answer, 'selected', true);
			
			if(this.questionIndex < (this.questions.length - 1)){
				setTimeout(() => {
					this.questionIndex++;
				}, this.autoNextQuestion);
			} else {
				setTimeout(() => {
					this.stopTimer();
					this.wrongAnswers = this.getWrongAnswersTotal();
					//save to google sheets
					this.save();
				}, this.autoNextQuestion);
			}
		},

		tryAgain: function(){
			this.step = 0;
			this.questionIndex = 0;
			this.timer = null;
			this.elapsedTime = 0;
			this.startTime = null;
			this.wrongAnswers = 0;
			this.form = {
				firstName: {
					value: '',
					hasError: false
				},
				lastName: {
					value: '',
					hasError: false	
				},
				nif: {
					value: '',
					hasError: false	
				},
				city: {
					value: '',
					hasError: false	
				},
				teamSize: {
					value: 0,
					hasError: false
				},
				email: {
					value: '',
					hasError: false
				},
				phone: {
					value: '',
					hasError: false
				},
				gama: {
					value: [],
					hasError: false
				},
				consent_registo: 'no',
				consent_marketing: 'no'
			};

			this.questions.forEach((question, qIndex) => {
				question.answers.forEach((answer, aIndex) => {
				  this.$delete(this.questions[qIndex].answers[aIndex], 'selected');
				  this.$delete(this.questions[qIndex].answers[aIndex], 'showCorrect');
				});
			});
		},

		getWrongAnswersTotal: function () {
			let correctTotal = 0;
			for (let i = 0; i <= (this.questions.length - 1); i++) {
				this.questions[i].answers.forEach((value, index) => {
					if (value.selected && value.correct) {
						correctTotal++;
					}
				});
			}
			return this.questions.length - correctTotal;
		},

		getSelectedAnswerForQuestion(index) {
			const question = this.questions[index];
			if (!question) {
			  return null; // Question not found
			}
		
			// Find the selected answer
			const selectedAnswer = question.answers.find(answer => answer.selected);
			return selectedAnswer ? selectedAnswer.text : null;
		},

		/**
		 * Save
		 */
		save: function () {
			var $this = this;
			var fd = new FormData();

			fd.append('first_name', $this.form.firstName.value);
			fd.append('last_name', $this.form.lastName.value);
			fd.append('nif', $this.form.nif.value);
			fd.append('city', $this.form.city.value);
			fd.append('email', $this.form.email.value);
			fd.append('phone', $this.form.phone.value);
			fd.append('gama', $this.form.gama.value);
			fd.append('consent_registo', $this.form.consent_registo);
			fd.append('consent_marketing', $this.form.consent_marketing);
			fd.append('time', $this.elapsedTime);
			fd.append('answer_1', $this.getSelectedAnswerForQuestion(0));
			fd.append('answer_2', $this.getSelectedAnswerForQuestion(1));
			fd.append('answer_3', $this.getSelectedAnswerForQuestion(2));
			fd.append('answer_4', $this.getSelectedAnswerForQuestion(3));
			fd.append('total_correct', ($this.questions.length - $this.wrongAnswers));
			fd.append('total_wrong', $this.wrongAnswers);

			if($this.form.teamSize.value == 0){
				fd.append('team_size', '0-5');
			} else if($this.form.teamSize.value == 1){
				fd.append('team_size', '5-10');
			} else if($this.form.teamSize.value == 2){
				fd.append('team_size', '10-20');
			} else if($this.form.teamSize.value == 3){
				fd.append('team_size', '>50');
			}

			$.blockUI();

			$.ajax({
				url: 'api/save',
				type: 'POST',
				data: fd,
				dataType: 'json',
				contentType: false,
				processData: false,
				success: function (r) {
					if (r.success) {
						$this.step = 7;
					}
					$.unblockUI();
				},
				error: function (r) {	
					alert('Ocorreu um erro.');
					$.unblockUI();
				}
			});
		}
	}
});